export default "__VITE_ASSET__C3Yg1xgF__"